import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import TestWebhookRunner from './TestWebhookRunner';

const TestWebhookModal = ({ open, onClose, webhookId, tin, profileId, name }) => {
  const [testing, setTesting] = useState(false);

  const handleClose = (event, reason) => {
    if (testing) return;
    if (reason === 'backdropClick') return;
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown={testing}
      PaperProps={{
        sx: {
          background: '#1e1e1e',
          borderRadius: 3,
        },
      }}
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" spacing={1} alignItems="center">
            <ElectricBoltIcon sx={{ color: '#6366f1' }} />
            <Typography fontWeight={600}>Test Webhook</Typography>
          </Stack>

          <IconButton
            onClick={onClose}
            disabled={testing}
            sx={{
              color: testing ? '#4b5563' : '#e5e7eb',
              cursor: testing ? 'not-allowed' : 'pointer',
            }}
          >
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          maxHeight: '70vh',
          overflowY: 'auto',
        }}
      >
        <TestWebhookRunner webhookId={webhookId} tin={tin} profileId={profileId} name={name} setTesting={setTesting} />
      </DialogContent>
    </Dialog>
  );
};

export default TestWebhookModal;
